export enum Partners {
    OPPO = 'oppo',
    REALME = 'realme',
    HERO_VIDA = 'hero_vida',
    XIAOMI = 'Xiaomi',
}

export enum LOB {
    EMBEDDED = 'embedded',
    AUTO = 'auto-lob',
    AUTO_PARTNERSHIP = 'auto-partnership',
}

export enum PurchaseJourney {
    V0 = 'v0',
    V1 = 'v1',
}

export enum Permissions {
    ADD_SUB_DEALERS = 'add_sub_dealer',
    REMOVE_SUB_DEALERS = 'remove_sub_dealer',
    COMMISSIONS_EARNED = 'commissions_earned',
    COMMISSIONS_EARNED_V1 = 'commissions_earned_v1',
    CUSTOMER_PDF = 'customer_pdf',
    GST_INVOICE = 'gst_invoice',
    REPORT_DASHBOARD = 'report_dashboard',
    PROFILE_DETAILS_SECTION = 'profile_details_section',
    WALLET_TRANSACTIONS = 'wallet_passbook',
    MANUAL_PURCHASE_FLOW = 'manual_purchase_flow',
    SCANNER = 'scanner',
}

export const LiquidDamage = {
    icon: '/icons/liquidDamage.svg',
    title: 'Liquid damage',
    subTitle: `Coffee spills? No problem, we'll fix that`,
};

export const AccidentalDamage = {
    icon: '/icons/accidentalDamage.svg',
    title: 'Accidental Damage',
    subTitle: `Dropped your device? We'll fix that too!`,
};

export const ScreenDamage = {
    icon: '/icons/liquidDamage.svg',
    title: 'Screen damage',
    subTitle: `Cracked your screen? We’ll replace it!`,
};

export const ElectronicsFailure = {
    icon: '/icons/electronics.svg',
    title: 'Electrical & mechanical failures',
    subTitle: `Device stopped working? We’ll fix it!`,
};

export const EtherPath = 'ether';

export const autoLobPartners = ['ather', 'hero_vida'];

export const autoPartnershipPartners = ['ackodrive'];
export enum Device {
    MOBILE = 'mobile',
    TABLET = 'tablet',
    APPLIANCE = 'appliance',
}

export const AckoLogoConfig = {
    gradient:
        'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg',
    light: 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/horizontal-reverse.svg',
    favicon: 'https://acko-brand.ackoassets.com/favicon/favicon.ico',
};

export const ERROR_MESSAGES = {
    VIN_VALIDATION_FAILED_MESSAGE: 'Vin Validation failed',
};

export const FORM_TYPES = {
    DEALER_DETAILS: 'dealer_details',
    SERVICE_CENTER_DETAILS: 'service_center_details',
    SERVICE_CENTER_PROFESSIONAL_DETAILS: 'service_center_professional_details',
    SERVICE_CENTER_BANK_DETAILS: 'service_center_bank_details',
    SERVICE_CENTER_POC_DETAILS: 'service_center_poc_details',
    SERVICE_CENTER_TNC: 'service_center_tnc',
};
